import { EnumApiScales, EnumScales } from '@library/store/measures/measures.interface';
import { getColorValue } from '@library/utils/helpers/functions/getColorVariable';
import { ChartConfiguration } from 'chart.js';
import { DeepPartial } from 'chart.js/types/utils';

export const baseConfig: DeepPartial<ChartConfiguration> = {
  options: {
    interaction: {
      mode: 'myCustomMode',
      intersect: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 500,
    },
    animations: {
      numbers: false,
      x: {
        type: 'number',
      }
    },
    resizeDelay: 500,
    layout: {
      padding: {
        bottom: -16,
        top: 0,
      },
    },
    scales: {
      x: {
        type: 'time',
        offset: false,
        grid: {
          tickLength: 0,
          drawOnChartArea: false,
          drawBorder: false,
        },
        ticks: {
          padding: 18,
          color: getColorValue('--grey'),
          maxRotation: 0,
          font: {
            family: "'ProximaNova-Bold', sans-serif",
            size: 11,
          },
        },
      },
      y: {
        beginAtZero: false,
        grid: {
          tickLength: 0,
          display: true,
          color: getColorValue('--grey-20'),
          borderDash: [5, 3],
          drawBorder: false,
        },
        ticks: {
          display: true,
          color: getColorValue('--grey'),
          font: {
            family: 'ProximaNova-semiBold',
            size: 9,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  },
};

export const SPAN_GAPS: Partial<Record<EnumApiScales, number>> = {
  [EnumApiScales.FIVE_MINUTES]: 1000 * 60 * 60 * 4, // 4 hours
  [EnumApiScales.THREE_HOURS]: 1000 * 60 * 60 * 24, // 1 day
  [EnumApiScales.ONE_DAY]: 1000 * 60 * 60 * 24 * 3, // three days
  [EnumApiScales.ONE_WEEK]: 1000 * 60 * 60 * 24 * 28, // 1 month ( 28 days for february )
};

export const BarThickness = {
  [EnumScales.DAY]: 6,
  [EnumScales.WEEK]: 6,
  [EnumScales.MONTH_DAILY]: 6,
  [EnumScales.YEAR]: 6,
};
